var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgXtwitIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5845_163788)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 23.9755C18.6142 23.9755 23.976 18.6137 23.976 11.9995C23.976 5.3853 18.6142 0.0234375 12 0.0234375C5.38581 0.0234375 0.0239563 5.3853 0.0239563 11.9995C0.0239563 18.6137 5.38581 23.9755 12 23.9755Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.9961 13.5915L14.8815 19.125H19.125L13.3573 10.9095L18.6627 4.875H17.4057L12.7969 10.1136L9.11851 4.875H4.875L10.4386 12.7974L4.875 19.125H6.13206L10.9961 13.5915ZM8.51648 5.80215L12.1371 10.8683L12.6993 11.6578L17.4051 18.2427H15.474L11.635 12.8668L11.0705 12.0774L6.58537 5.80215H8.51648Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5845_163788"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXtwitIcon);
export default __webpack_public_path__ + "static/media/xtwit_icon.3147057ed6bcc42855b94d294d421373.svg";
export { ForwardRef as ReactComponent };